import { Component }	from '@angular/core';


import {
	AppState
}														from '../../';
import {
	ConfigService,
	StateService
}														from '../../service';

export interface MenuWrapperState {
	about:	boolean;
	filter:	boolean;
	iab:		boolean;
	legend:	boolean;
	more:		boolean;
	terms:	boolean;
}

@Component({
  selector:			'electra-menu-wrapper',
  styleUrls:		['./menuWrapper.component.scss'],
  templateUrl:	'./menuWrapper.component.html'
})
export class MenuWrapperComponent {
	state:	MenuWrapperState;

	desktopClass = '';

	legendTop = 0;
  filterTop = 0;

  get aboutClass(): string {
    return (this.state.about ? '' : 'hide') + ' full ' + this.desktopClass;
  }

  get filterClass(): string {
    return (this.state.filter ? '' : 'hide') + ' partial ' + this.desktopClass;
  }

  get iabClass(): string {
    return (this.state.iab ? '' : 'hide') + (this.configService.mobile ? ' full' : ' partial') + this.desktopClass;
  }

  get legendClass(): string {
    return (this.state.legend ? '' : 'hide') + ' partial ' + this.desktopClass;
  }

	get legendStyle(): any {
		return this.state.legend ? {
			transition: 'transform ' + (this.legendTop > 0 ? 0 : 0.25) + 's ease',
			transform: 	'translate3d(0, ' + this.legendTop + 'px, 0)'
		} : {}
	}

  get filterStyle(): any {
		return this.state.filter ? {
			transition: 'transform ' + (this.filterTop > 0 ? 0 : 0.25) + 's ease',
			transform: 	'translate3d(0, ' + this.filterTop + 'px, 0)'
		} : {}
  }

	get menuClass(): string {
    return this.desktopClass;
  }

  get moreClass(): string {
    return (this.state.more ? '' : 'hide') + (this.configService.mobile ? ' full' : ' partial') + this.desktopClass;
  }

  get termsClass(): string {
    return (this.state.terms ? '' : 'hide') + ' full ' + this.desktopClass;
  }

	constructor(public configService: ConfigService, public stateService: StateService) {
		stateService.app.subscribe(data => { this.gotState(data); });

		this.desktopClass = configService.mobile ? '' : ' desktop';
	}

	gotState(state: MenuWrapperState) {
		this.state = state;

		if (!this.state.legend || !this.state.filter) {
			this.legendTop = 0;
      this.filterTop = 0;
		}

	}

	gotLegendTop(newValue: number) {
		this.legendTop = newValue;
	}

	gotFilterTop(newValue: number) {
		this.filterTop = newValue;
	}

}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/menuWrapper/menuWrapper.component.ts